import { motion } from "framer-motion";
import { Users, HandHeart, HeartHandshake } from "lucide-react";
import { IMAGES } from "../lib/content";

const ELEMENTS = [
  [Users, "Socialising", "Sharing ordinary time — kai, laughter, mahi — with people who know you. Activities are simply more satisfying shared, and shared time builds the willingness to help each other."],
  [HandHeart, "Social support", "Knowing someone would be there if you needed them — emotionally, practically, or with the right information. Just believing support is available reduces anxiety and depression."],
  [HeartHandshake, "Sense of belonging", "Feeling connected to and valued by other people — part of something greater than yourself. Belonging is a protective factor; loneliness is a risk factor."],
];

export default function Connectedness() {
  return (
    <section id="connection" className="bg-[#F5F2EC] text-[#1A1A1A] py-24 sm:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mono-label text-[#1E4B3E] mb-4">The evidence for hope</motion.p>
            <motion.h2 initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="font-display font-extrabold uppercase text-3xl sm:text-5xl tracking-tight mb-6 text-[#1E4B3E]">
              Connection is protection
            </motion.h2>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="text-[#52525B] leading-relaxed mb-6">
              Addiction isolates. Recovery reconnects. A major New Zealand literature review — <em>The Measurement of Social Connectedness and its Relationship to Wellbeing</em> (Frieling, Krassoi Peach &amp; Cording, Ministry of Social Development, 2018) — found social connectedness rests on three elements, each one a protective factor for wellbeing and resilience:
            </motion.p>
            <div className="space-y-4">
              {ELEMENTS.map(([Icon, name, desc], i) => (
                <motion.div key={name} initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                  className="flex gap-4 bg-white border border-[#E2DCD2] rounded-xl p-5">
                  <Icon size={22} className="text-[#1E4B3E] shrink-0 mt-0.5" />
                  <div>
                    <h4 className="font-display font-bold text-sm uppercase tracking-wide mb-1">{name}</h4>
                    <p className="text-sm text-[#52525B] leading-relaxed">{desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
            <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="mt-6 text-sm text-[#52525B] border-l-2 border-[#D97706] pl-4">
              The same body of research found a lack of social connection predicts early death as strongly as major health-risk behaviours like smoking — and that in New Zealand data, connectedness predicted better mental health year-on-year more consistently than the reverse. This is why Break the Cycle builds community, whānau and belonging — not just information.
            </motion.p>
          </div>
          <motion.div initial={{ opacity: 0, scale: 0.97 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="clipped-frame">
            <img src={IMAGES.whanau} alt="Whānau gathered together outdoors" className="w-full h-[480px] object-cover" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
